var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AutoComplete',{attrs:{"data":_vm.emailArr,"placeholder":"请输入"},on:{"on-search":function($event){return _vm.emailSearch($event)}},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }